import type { FBQSubscriptionValue } from './types';
import { createSubscriptionMap } from '../core/subscription';

export const DEFAULT_FBQ_PIXEL_ID = '890136619997943';

/**
 * FBQ 套餐价格映射表
 */
export const FBQ_SUBSCRIPTION_MAP = createSubscriptionMap<FBQSubscriptionValue>(({ value, name }) => ({
  value,
  content_name: name,
}));
